export function spaceDetail(spaces, priceRefinement) {
  let bySf = spaces.sort((a, b) => a.sf - b.sf);
  let byPrice = spaces.sort((a, b) => a.price - b.price);
  if (priceRefinement) {
    byPrice = byPrice.filter(space => {
      return (
        space.price >= priceRefinement.min && space.price <= priceRefinement.max
      );
    });
    if (byPrice.length === 0) {
      return 'none';
    }

    bySf = byPrice.sort((a, b) => a.sf - b.sf);
  }

  let sqF = `${bySf[0].sf.toLocaleString()}`;
  if (bySf.length > 1) {
    sqF += ` - ${bySf[bySf.length - 1].sf.toLocaleString()}`;
  }
  let priceRange = `${Number(
    (byPrice[0].price / 12).toFixed(),
  ).toLocaleString()}`;
  if (byPrice.length > 1) {
    priceRange += ` - ${Number(
      (byPrice[byPrice.length - 1].price / 12).toFixed(),
    ).toLocaleString()}`;
  }

  return [sqF, priceRange];
}

export let libraries = ['places'];
